import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

/**
 * Uses the React Bootstraps Modal to create a popup for the calendar
 */
function Popup({ show, handleClose, title, description, time, location }) {
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Date: {description}
                {time ? (
                    <>
                        <br />
                        Time: {time}
                    </>
                ) : null}
                {location ? (
                    <>
                        <br />
                        Location: {location}
                    </>
                ) : null}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default Popup;
